function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Passport = /*#__PURE__*/function () {
  function Passport() {
    _classCallCheck(this, Passport);
    this.hooks = {};
    this.error = '';
  }
  return _createClass(Passport, [{
    key: "attach",
    value: function attach(root) {
      var _this = this;
      var hooks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.hooks = hooks;
      if (!root || root.dataset.passportBound === '1') {
        return;
      }
      root.dataset.passportBound = '1';
      root.addEventListener('click', function (event) {
        if (event.target.closest('[data-passport-file]')) {
          return;
        }
        if (event.target.closest('[data-passport-remove]')) {
          var _this$hooks$onRemove, _this$hooks;
          event.preventDefault();
          _this.error = '';
          (_this$hooks$onRemove = (_this$hooks = _this.hooks).onRemove) === null || _this$hooks$onRemove === void 0 || _this$hooks$onRemove.call(_this$hooks);
          return;
        }
        if (event.target.closest('[data-passport-choose]')) {
          var _root$querySelector;
          event.preventDefault();
          (_root$querySelector = root.querySelector('[data-passport-file]')) === null || _root$querySelector === void 0 || _root$querySelector.click();
          return;
        }
        if (event.target.closest('[data-passport-drop]')) {
          var _root$querySelector2;
          (_root$querySelector2 = root.querySelector('[data-passport-file]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.click();
        }
      });
      root.addEventListener('keydown', function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && event.target.closest('[data-passport-drop]')) {
          var _root$querySelector3;
          event.preventDefault();
          (_root$querySelector3 = root.querySelector('[data-passport-file]')) === null || _root$querySelector3 === void 0 || _root$querySelector3.click();
        }
      });
      root.addEventListener('change', function (event) {
        var _input$files;
        var input = event.target.closest('[data-passport-file]');
        if (input !== null && input !== void 0 && (_input$files = input.files) !== null && _input$files !== void 0 && _input$files[0]) {
          _this.readFile(input.files[0], root);
          input.value = '';
        }
      });
      root.addEventListener('dragover', function (event) {
        if (event.target.closest('[data-passport-drop]')) {
          event.preventDefault();
          event.target.closest('[data-passport-drop]').classList.add('dragging');
        }
      });
      root.addEventListener('dragleave', function (event) {
        var _event$target$closest;
        (_event$target$closest = event.target.closest('[data-passport-drop]')) === null || _event$target$closest === void 0 || _event$target$closest.classList.remove('dragging');
      });
      root.addEventListener('drop', function (event) {
        var _event$dataTransfer;
        var drop = event.target.closest('[data-passport-drop]');
        if (!drop) {
          return;
        }
        event.preventDefault();
        drop.classList.remove('dragging');
        var file = (_event$dataTransfer = event.dataTransfer) === null || _event$dataTransfer === void 0 || (_event$dataTransfer = _event$dataTransfer.files) === null || _event$dataTransfer === void 0 ? void 0 : _event$dataTransfer[0];
        if (file) {
          _this.readFile(file, root);
        }
      });
    }
  }, {
    key: "readFile",
    value: function () {
      var _readFile = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(file, root) {
        var _file$type;
        var _this$hooks$onUpload, _this$hooks2, buffer, image, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if ((_file$type = file.type) !== null && _file$type !== void 0 && _file$type.startsWith('image/')) {
                _context.n = 1;
                break;
              }
              this.fail(root, 'Choose an image file.');
              return _context.a(2);
            case 1:
              if (!(file.size > 12 * 1024 * 1024)) {
                _context.n = 2;
                break;
              }
              this.fail(root, 'Choose an image smaller than 12 MB.');
              return _context.a(2);
            case 2:
              _context.p = 2;
              _context.n = 3;
              return file.arrayBuffer();
            case 3:
              buffer = _context.v;
              image = "data:".concat(file.type, ";base64,").concat(Buffer.from(buffer).toString('base64'));
              this.error = '';
              (_this$hooks$onUpload = (_this$hooks2 = this.hooks).onUpload) === null || _this$hooks$onUpload === void 0 || _this$hooks$onUpload.call(_this$hooks2, image);
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.fail(root, 'That passport image could not be read.');
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[2, 4]]);
      }));
      function readFile(_x, _x2) {
        return _readFile.apply(this, arguments);
      }
      return readFile;
    }()
  }, {
    key: "fail",
    value: function fail(root, message) {
      var _this$hooks$onError, _this$hooks3;
      this.error = message;
      var node = root.querySelector('[data-passport-error]');
      if (node) {
        node.textContent = message;
      }
      (_this$hooks$onError = (_this$hooks3 = this.hooks).onError) === null || _this$hooks$onError === void 0 || _this$hooks$onError.call(_this$hooks3, message);
    }
  }]);
}();
module.exports = Passport;